import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import FirstSlider from "./HeaderSliders/FirstSlider";
import SecondSlider from "./HeaderSliders/SecondSlider";
import ThirdMainSlider from "./HeaderSliders/ThirdMainSlider";
import FourthBannerSlider from "./HeaderSliders/FourthBannerSlider";
import HeaderWrapper from "./Header/HeaderWrapper";
import FooterWrapper from "./Footer/FooterWrapper";
import VideoBgSection from "./Home/VideoBgSection";
import HospitalWhoWeAreWrapper from "./HospitalWhoWeAre/HospitalWhoWeAreWrapper";
import DoctorWhoWeAreWrapper from "./DoctorWhoWeAre/DoctorWhoWeAreWrapper";
import HomeNewsWrapper from "./NewsUpdates/HomeNewsWrapper";
import HomeSpecialitiesWrapper from "./Services/HomeSpecialitiesWrapper";
import MeetOurSpecialiistsWrapper from "./MeetOurSpecialists/MeetOurSpecialiistsWrapper";
import HomeeFacilitiesWrapper from "./HomeFacilities/HomeeFacilitiesWrapper";
import HomeReviewsWrapper from "./Reviews/HomeReviewsWrapper";
import CeoMessageWrapper from "./CeoMessage/CeoMessageWrapper";
import WrapperVisionMissionValue from "./HospitalWhoWeAre/WrapperVisionMissionValue";
import { SendPostRequest } from "../http";
import CharitySlider from "./HeaderSliders/CharitySlider";
import VedioBannerSlider from "./HeaderSliders/VedioBannerSlider";
import ZoomInSlider from "./HeaderSliders/ZoomInSlider";
import CarousalSlider from "./HeaderSliders/CarousalSlider";
import BoxImageSlider from "./HeaderSliders/BoxImageSlider";
import PuzzleSlider from "./HeaderSliders/PuzzleSlider";
import EmistSlider from "./HeaderSliders/EmistSlider";
import CubeSliderMain from "./HeaderSliders/CubeSliderMain";
import ModernSlider from "./HeaderSliders/ModernSlider";
import FadeSlider from "./HeaderSliders/FadeSlider";
import ResolutionSlider from "./HeaderSliders/ResolutionSlider";
import SliderNew from "./HeaderSliders/SliderNew";
import DayCounter from "./DayCounter";
import BlogsHomeWrapper from "./Blogs/Home/BlogsHomeWrapper";

export default function Home({ isData, setIsdata }) {
  const sitedata = useSelector((store) => store.global.loginData);

  const [homeIntroData, setHomeIntroData] = useState({});

  useEffect(() => {
    getHomeIntroData();
  }, []);

  const getHomeIntroData = async () => {
    const response = await SendPostRequest("content/home");
    setHomeIntroData(response?.data);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const sections = [
    {
      key: "introduction",
      component:
        sitedata?.site_type === "hospitals" ? (
          <HospitalWhoWeAreWrapper />
        ) : (
          <DoctorWhoWeAreWrapper />
        ),
    },
    {
      key: "vision_mission_values",
      component: sitedata?.manage_home_page?.vision_mission_values?.Status === 1 &&
        <div className="row">
          <div className="col-12">
            <WrapperVisionMissionValue
              principles={homeIntroData?.principles}
              siteType={sitedata?.site_type}
            />
          </div>
        </div>

    },
    {
      // key: sitedata?.site_type === "hospitals" ? "specialities" : "services",
      // component: <HomeSpecialitiesWrapper setIsdata={setIsdata} />,
      key: "specialities",
      component: <HomeSpecialitiesWrapper setIsdata={setIsdata} />,
      // component: sitedata?.site_type === "hospitals" ? <HomeSpecialitiesWrapper setIsdata={setIsdata} /> : null,
      // <HomeSpecialitiesWrapper setIsdata={setIsdata} />,
    },
    {
      key: "facilities",
      component:
        sitedata?.site_type === "hospitals" ? <HomeeFacilitiesWrapper /> : null,
    },
    {
      key: "latest_news",
      component: <HomeNewsWrapper />,
    },
    {
      key: "blogs",
      component: sitedata?.site_type === "doctors" ? <BlogsHomeWrapper /> : null,
    },
    {
      key: "ceo_message",
      component: <CeoMessageWrapper />,
    },
    {
      key: "specialists",
      component: <MeetOurSpecialiistsWrapper />,
    },
    {
      key: "cta_banner",
      component:
        sitedata?.advertisement?.short_detail_for_button &&
          sitedata?.advertisement?.button_url &&
          sitedata?.advertisement?.button_name ? (
          <section
            id="get-quote-section"
            className="get-quote-section bg-theme pad-top-40 pad-bottom-50 relative index-1"
          >
            <div className="container">
              <div className="row get-quote-3">
                <div className="col-lg-12">
                  <div className="title-wrap mb-0">
                    <div className="section-title text-center mb-3">
                      <h3 className="title text-uppercase home-discount-offer">
                        {sitedata?.advertisement?.short_detail_for_button}
                      </h3>
                    </div>
                  </div>
                  <div className="button justify-content-center d-flex">
                    <Link
                      to={sitedata?.advertisement?.button_url}
                      className="btn btn-border ms-3"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {sitedata?.advertisement?.button_name}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </section>
        ) : null,
    },
    {
      key: "patient_reviews",
      component: <HomeReviewsWrapper />,
    },
  ];

  const orderedSections = sections
    .filter(
      (sec) =>
        sitedata?.manage_home_page?.[sec.key]?.Status === 1 && sec.component
    )
    .sort(
      (a, b) =>
        sitedata?.manage_home_page?.[a.key]?.Order -
        sitedata?.manage_home_page?.[b.key]?.Order
    );

  return (
    <div className="page-wrapper-inner">
      <HeaderWrapper />

      {/* Banner selection */}
      {sitedata?.theme_banner_transition === "animation" ? (
        <SecondSlider />
      ) : sitedata?.theme_banner_transition === "version3" ? (
        <ThirdMainSlider />
      ) : sitedata?.theme_banner_transition === "version4" ? (
        <FourthBannerSlider />
      ) : sitedata?.theme_banner_transition === "slide_zoom_hero" ? (
        <CubeSliderMain />
      ) : sitedata?.theme_banner_transition === "carousal_slider" ? (
        <CarousalSlider />
      ) : sitedata?.theme_banner_transition === "carousal_fade" ? (
        <ZoomInSlider />
      ) : sitedata?.theme_banner_transition === "owl_slider_fade" ? (
        <FadeSlider />
      ) : sitedata?.theme_banner_transition === "mouse_parallax" ? (
        <ResolutionSlider />
      ) : sitedata?.theme_banner_transition === "layered_parallax" ? (
        <PuzzleSlider />
      ) : (
        <FirstSlider />
      )}

      {/* <CubeSliderMain /> */}
      {/* <CarousalSlider /> */}
      {/* <ZoomInSlider /> */}
      {/* <FadeSlider /> */}
      {/* <ResolutionSlider />  */}
      {/* <FirstSlider /> */}
      {/* <SecondSlider /> */}
      {/* <ThirdMainSlider /> */}
      {/* <FourthBannerSlider /> */}
      {/* <PuzzleSlider /> */}



      {/* {sitedata?.options?.banner_style === "animation" ? (
        <SecondSlider />
      ) : sitedata?.options?.banner_style === "version3" ? (
        <ThirdMainSlider />
      ) : sitedata?.options?.banner_style === "version4" ? (
        <FourthBannerSlider />
      ) : sitedata?.options?.banner_style === "slide_zoom_hero" ? (
        <CubeSliderMain />
      ) : sitedata?.options?.banner_style === "carousal_slider" ? (
        <CarousalSlider />
      ) : sitedata?.options?.banner_style === "carousal_fade" ? (
        <ZoomInSlider />
      ) : sitedata?.options?.banner_style === "owl_slider_fade" ? (
        <FadeSlider />
      ) : sitedata?.options?.banner_style === "mouse_parallax" ? (
        <ResolutionSlider />
      ) : (
        <FirstSlider />
      )} */}

      {/* : sitedata?.options?.banner_style === "version4" ? (
        <FourthBannerSlider />
      ) */}
      {/* <CubeSliderMain /> */}
      {/* <CarousalSlider />  */}
      {/* <ZoomInSlider/> */}
      {/* <FadeSlider /> */}

      {/* <PuzzleSlider /> */}

      {/* <VedioBannerSlider /> */}

      {/* <ResolutionSlider /> */}



      {/* <ModernSlider/> */}
      {/* <BoxImageSlider/> */}
      {/* <EmistSlider/> */}
      {/* <CharitySlider/> */}

      {/* <SliderNew /> */}
      {/* <CarousalSlider />  */}





      {orderedSections.map((sec, i) => (
        <div key={i}>{sec.component}</div>
      ))}



      <DayCounter />

      <VideoBgSection />
      <FooterWrapper />
    </div>
  );
}
